import { SvgIcon } from "@mui/material"

import { ReactComponent as SurfaceIcon } from "./Surface.svg"

export const RoadSurfaceIcon = (props) => {
    return (
        <SvgIcon component={SurfaceIcon} {...props} inheritViewBox />
    )
}